export default {
  components: {}
}

// proposal....

// let components = {}

// export default {
//   components,

//   set (component, vm) {
//     components = {
//       ...components,
//       components: vm
//     }
//   },

//   get (component) {
//     return components[component]
//   }
// }
